<template>
  <SidebarProvider
    v-model:open="sidebarState"
  >
    <slot />
  </SidebarProvider>
</template>

<script setup>
import { useLocalStorage, watchImmediate } from '@vueuse/core'
import StorageKeys from '@/common/storage-keys.js'
import { useTeamExtra } from '@/hooks/use-team-extra.js'
import { SidebarProvider } from '@/shadcn/components/ui/sidebar'

const sidebarState = useLocalStorage(StorageKeys.SIDEBAR_STATE, false)
const { disableOttoChat } = useTeamExtra()

watchImmediate(disableOttoChat, (disabled) => {
  if (disabled) {
    sidebarState.value = false
  }
})
</script>
